import { render, staticRenderFns } from "./catalogueList.vue?vue&type=template&id=52b05546&scoped=true"
import script from "./catalogueList.vue?vue&type=script&lang=js"
export * from "./catalogueList.vue?vue&type=script&lang=js"
import style0 from "./catalogueList.vue?vue&type=style&index=0&id=52b05546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b05546",
  null
  
)

export default component.exports